import React from 'react';

const LogoAcg = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 720 800"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_728_8)">
        <path
          clipRule="evenodd"
          d="M500.746 346.856L360.699 104L0 729.49H90.5349L273.932 413.432L351.326 606.125L500.746 346.856ZM517.144 375.294L344.707 675.964L311.102 593.381L232.499 729.49H721.398L517.144 375.294Z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
};

export default LogoAcg; // Named default export
